import faireLogo from '../../assets/experience-badges/faire.png';
import watershedLogo from '../../assets/experience-badges/watershed.png';
import biorenderLogo from '../../assets/experience-badges/biorender.png';
import waterlooLogo from '../../assets/experience-badges/waterloo.png';

export const EXPERIENCE_BADGE_CASES = [
  {
    id: 'full-time',
    label: 'Full-Time',
    badges: [
      {
        id: 'watershed-current',
        name: 'Watershed',
        role: 'Data Infrastructure Engineer',
        detail: 'Current · San Francisco',
        term: 'NOW',
        logo: watershedLogo,
        isCurrent: true,
      },
    ],
  },
  {
    id: 'internships',
    label: 'Internships',
    badges: [
      {
        id: 'watershed-intern-2024',
        name: 'Watershed',
        role: 'Software Engineer Intern',
        detail: 'May–Aug 2024 · San Francisco',
        term: 'S24',
        logo: watershedLogo,
      },
      {
        id: 'faire-security-2023',
        name: 'Faire',
        role: 'Backend Engineer Intern · Information Security',
        detail: 'Sep–Dec 2023 · Toronto',
        term: 'F23',
        logo: faireLogo,
      },
      {
        id: 'biorender-growth-2023',
        name: 'BioRender',
        role: 'Fullstack Developer Intern · Growth',
        detail: 'Jan–Apr 2023 · Toronto',
        term: 'W23',
        logo: biorenderLogo,
      },
      {
        id: 'faire-frontend-2022',
        name: 'Faire',
        role: 'Frontend Engineer Intern',
        detail: 'May–Aug 2022 · Toronto',
        term: 'S22',
        logo: faireLogo,
      },
      {
        id: 'faire-frontend-2021',
        name: 'Faire',
        role: 'Frontend Engineer Intern',
        detail: 'Sep–Dec 2021 · Toronto',
        term: 'F21',
        logo: faireLogo,
      },
    ],
  },
  {
    id: 'education',
    label: 'Education',
    badges: [
      {
        id: 'waterloo',
        name: 'University of Waterloo',
        role: 'Systems Design Engineering, BASc',
        detail: 'AI + Computing options · 2020–2025',
        term: 'BASc',
        logo: waterlooLogo,
      },
    ],
  },
];
